<template>
    <div class="choose-user-login-mobile">
        <div class="user-identity-list">
            <div
                class="user-identity-item user-member"
                :class="{ selected: curChooseCareerSelected === 1 }"
                @click="_hdanleChooseCareerSelected(1)"
            >
                <div class="user-identity-item-name">Member</div>
            </div>

            <div
                class="user-identity-item user-doctor"
                :class="{ selected: curChooseCareerSelected === 2 }"
                @click.stop="_hdanleChooseCareerSelected(2)"
            >
                <div class="user-identity-item-name">Doctor</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
import { UserRole } from "@/constant";

const props = defineProps({
    curRoleType: {
        type: String,
        default: () => {
            return "";
        },
    },
});
const emits = defineEmits(["onNext"]);

const curChooseCareerSelected = ref<number>(0);
const isDisabledChooseCareerSelected = computed(() => {
    return curChooseCareerSelected.value ? false : true;
});

watch(
    () => props.curRoleType,
    (newV) => {
        curChooseCareerSelected.value =
            newV === UserRole.User.toUpperCase()
                ? 1
                : newV === UserRole.Doctor.toUpperCase()
                ? 2
                : 0;
    },
    { immediate: true }
);

// 注册-选择完职业之后点击next按钮
const _handleChooseCareerNext = () => {
    if (isDisabledChooseCareerSelected.value) {
        MessageAlert("Please choose a User identity");
        return;
    }
    emits("onNext", curChooseCareerSelected.value);
};

const _hdanleChooseCareerSelected = (type: number) => {
    curChooseCareerSelected.value = type;
    _handleChooseCareerNext();
};
</script>

<style lang="scss" scoped>
.choose-user-login-mobile {
    width: 100%;
    .user-identity-list {
        width: 100%;
        .user-identity-item {
            display: flex;
            width: 90%;
            margin: 24px auto 0 auto;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            border: 1px solid rgba($color: #000000, $alpha: 0.2);
            border-radius: 2px;
            background-color: #ffffff;
            cursor: pointer;

            // &.selected {
            //     border: 1px solid #000000;
            // }

            .user-identity-item-name {
                width: 100%;
                height: 60px;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 60px;
                text-align: center;
            }
        }

        .user-doctor {
            border: 1px solid rgba(255, 255, 255, 0.6);
            background-color: #000000;

            .user-identity-item-name {
                color: rgba(255, 255, 255, 0.6);
            }
        }
    }
}
</style>
